import { template as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

const TestData = {
  featuredContent: [
    {
      fields: {
        featuredImg: 'https://images',
        name: 'Featured content name',
        slug: '/featured-content-slug',
        isExternal: false,
      },
    },
  ],
  contentHeader: 'Featured content header',
  viewAllContentButtonText: 'View all content',
  showViewAllContentButton: true,
  viewAllContentSlug: '/view-all-content',
};

export default fakeProps(schema, TestData);
